import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × CHANEL: Monochrome order and timeless modernity
// Black-white contrast, diamond grids, double-C symmetry
export function VasarelyChanelMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Pure white background */}
      <rect x="0" y="0" width="794" height="1123" fill={brand.white} />

      <g transform="translate(397 540)">
        {/* Diamond grid pattern (quilted perfection) */}
        {Array.from({ length: 16 }).map((_, i) =>
          Array.from({ length: 20 }).map((_, j) => {
            const x = (i - 7.5) * 40;
            const y = (j - 9.5) * 40;
            
            return (
              <g key={`${i}-${j}`}>
                <path
                  d={`M ${x} ${y - 18} L ${x + 18} ${y} L ${x} ${y + 18} L ${x - 18} ${y} Z`}
                  fill={(i + j) % 2 === 0 ? brand.black : brand.white}
                  stroke={brand.black}
                  strokeWidth="1"
                  opacity="0.8"
                />
              </g>
            );
          })
        )}

        {/* Double-C symmetry (iconic interlocking) */}
        {[-1, 1].map((dir) => (
          <g key={dir}>
            <circle
              cx={dir * 60}
              cy="0"
              r="80"
              fill="none"
              stroke={brand.black}
              strokeWidth="12"
              opacity="0.8"
            />
            <circle
              cx={dir * 60}
              cy="0"
              r="68"
              fill={brand.white}
            />
          </g>
        ))}

        {/* Monochrome contrast lines */}
        {Array.from({ length: 24 }).map((_, i) => {
          const angle = (i * Math.PI) / 12;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 280}
              y2={Math.sin(angle) * 280}
              stroke={brand.black}
              strokeWidth="1"
              opacity="0.15"
            />
          );
        })}

        {/* Timeless geometric frames */}
        <rect x="-200" y="-180" width="400" height="360" fill="none" stroke={brand.black} strokeWidth="4" opacity="0.8" />
        <rect x="-190" y="-170" width="380" height="340" fill="none" stroke={brand.black} strokeWidth="1" opacity="0.4" />

        {/* Binary purity nodes */}
        {[
          { x: -180, y: -160 },
          { x: 180, y: -160 },
          { x: -180, y: 160 },
          { x: 180, y: 160 },
        ].map((node, i) => (
          <circle
            key={i}
            cx={node.x}
            cy={node.y}
            r="6"
            fill={brand.black}
          />
        ))}
      </g>

      {/* Chanel text */}
      <text x="397" y="95" textAnchor="middle" fontFamily="sans-serif" fontWeight="600" fontSize="14" fill={brand.black} opacity="0.8">
        MONOCHROME MODERNITÉ
      </text>
    </g>
  );
}
